import getProcessActivities from './getProcessActivitiesSaga';
import saveTaskForm from './saveTaskFormSaga';
import submitTaskForm from './submitTaskFormSaga';
import taskSagas from './task';

export default [getProcessActivities, saveTaskForm, submitTaskForm, ...taskSagas];
